<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <p [innerHTML]="data.text"></p>
    <pre>{{data.content}}</pre>
</mat-dialog-content>